import { Box} from '@chakra-ui/react'
import GruntComponents from '../components';
import ComponentHeader from './ComponentHeader';



const Postavke = ({onClosePress}) => {
    
    return (
        
        <Box  w={'99%'} pt='0.5rem'>
            <ComponentHeader onClosePress={onClosePress} component={GruntComponents.Postavke}/>
            <Box pl='2'>
                Postavke sadržaj
            </Box>
        </Box>
    );
}

export default Postavke;